import { Component, Input } from '@angular/core';
import { ValidationErrors } from 'src/types/error-response';
import { KeyValuePipe } from '@angular/common';

@Component({
  selector: 'app-validation-errors',
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.component.scss'],
  imports: [KeyValuePipe],
})
export class ValidationErrorsComponent {
  @Input({ required: true }) validationErrors!: ValidationErrors;
}
